import { useIntl } from "react-intl";
import React from "react";
import CongelacaoContainer from "./congelacao.container";

function CongelacaoContainerIntl() {
    const intl = useIntl()
    return (
        <CongelacaoContainer intl={intl}></CongelacaoContainer>
    );
  }

  export default CongelacaoContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/congelacao/congelacao.intl.js